import React from 'react';
import { ReactComponent as Microsoft } from '../assets/microsoft.svg';
import { ReactComponent as Netflix } from '../assets/netflix.svg';
import { ReactComponent as Meta } from '../assets/meta.svg';
import { ReactComponent as Deloitte } from '../assets/deloitte.svg';
import { ReactComponent as JPMorgan } from '../assets/jp-morgan.svg';
import { ReactComponent as GoldmanSachs } from '../assets/goldman-sachs.svg';
import { ReactComponent as McKinsey } from '../assets/mckinsey.svg';
import { ReactComponent as Tesla } from '../assets/tesla.svg';
import { ReactComponent as Uber } from '../assets/uber.svg';

const CompaniesSection = () => {
  const companies = [
    { name: "Google", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg", type: "svg" },
    { name: "Apple", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apple/apple-original.svg", type: "svg" },
    { name: "Microsoft", logo: Microsoft, type: "component" },
    { name: "Amazon", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg", type: "svg" },
    { name: "Netflix", logo: Netflix, type: "component" },
    { name: "Meta", logo: Meta, type: "component" },
    { name: "Deloitte", logo: Deloitte, type: "component" },
    { name: "JPMorgan", logo: JPMorgan, type: "component" },
    { name: "Goldman Sachs", logo: GoldmanSachs, type: "component" },
    { name: "McKinsey", logo: McKinsey, type: "component" },
    { name: "Tesla", logo: Tesla, type: "component" },
    { name: "Uber", logo: Uber, type: "component" },
  ];

  return (
    <section id="section-3" className="py-20 bg-gradient-to-b from-orange-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Top companies hiring
          </h2>
          <p className="text-lg text-gray-600 mt-2">
            We've helped people land jobs at these incredible companies
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div className="flex animate-scroll-fast gap-8 whitespace-nowrap">
            {[...companies, ...companies].map((company, index) => (
              <div
                key={index}
                className="flex-shrink-0 px-4 py-2 min-w-fit text-center hover:scale-105 transition-transform duration-300"
              >
                <div className="w-20 h-20 mx-auto mb-2 flex items-center justify-center">
                  {company.type === 'svg' ? (
                    <img
                      src={company.logo}
                      alt={`${company.name} logo`}
                      className="w-full h-full object-contain grayscale hover:grayscale-0 transition-all duration-300"
                    />
                  ) : company.type === 'component' ? (
                    <company.logo
                      className="w-full h-full object-contain grayscale hover:grayscale-0 transition-all duration-300"
                    />
                  ) : (
                    <div className="text-5xl">{company.logo}</div>
                  )}
                </div>
                <h3 className="text-sm font-medium text-gray-800 whitespace-normal">{company.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompaniesSection;
